// style for button hover
import styled, { css } from 'styled-components';
import { flex, media } from 'components/styles';

export const baseRootStyle = css`
	width: ${({ width }) => width}px;
	height: ${({ height }) => height}px;
	text-decoration: none;
	position: relative;
	color: white;

	&:hover {
		color: white;
	}
`;

export const Content = styled.section`
	${flex()};
	column-gap: 0.5em;
	${media.min.min(css`
		column-gap: 1em;
	`)}
`;

export const ButtonContainer = styled.div.attrs(({ show }) => ({
	style: {
		opacity: show ? '1' : '0'
	}
}))`
	position: absolute;
	height: 100%;
	width: 100%;
	transition: opacity ease 150ms;
`;

export const backgroundDefault = ({
	gradientButton: { backgroundDefault }
}) => [
	{ offset: 0, color: backgroundDefault.color1 },
	{ offset: 39.63, color: backgroundDefault.color2 },
	{ offset: 67.28, color: backgroundDefault.color3 },
	{ offset: 100, color: backgroundDefault.color4 }
];

export const backgroundHovered = ({
	gradientButton: { backgroundHovered }
}) => [
	{ offset: 0, color: backgroundHovered.color1 },
	{ offset: 39.63, color: backgroundHovered.color2 },
	{ offset: 67.4, color: backgroundHovered.color3 },
	{ offset: 100, color: backgroundHovered.color4 }
];

export const borderDefault = ({ gradientButton: { borderDefault } }) => [
	{ offset: 0, color: borderDefault.color1 },
	{ offset: 34.37, color: borderDefault.color2 },
	{ offset: 100, color: borderDefault.color3 }
];

export const borderHovered = ({ gradientButton: { borderHovered } }) => [
	{ offset: 0, color: borderHovered.color1 },
	{ offset: 34.37, color: borderHovered.color2 },
	{ offset: 100, color: borderHovered.color2 }
];

// tv smart
export const smartBackgroundHovered = ({
	gradientButton: { smartBackgroundHovered }
}) => [
	{ offset: 0, color: smartBackgroundHovered.color1 },
	{ offset: 39.63, color: smartBackgroundHovered.color2 },
	{ offset: 67.4, color: smartBackgroundHovered.color3 },
	{ offset: 100, color: smartBackgroundHovered.color4 }
];

export const smartBorderHovered = ({
	gradientButton: { smartBorderHovered }
}) => [
	{ offset: 0, color: smartBorderHovered.color1 },
	{ offset: 34.37, color: smartBorderHovered.color2 },
	{ offset: 100, color: smartBorderHovered.color3 }
];

export const rejectGradientButton = css`
	cursor: pointer;
	background: radial-gradient(
			57.43% 157.84% at 30.18% 5.11%,
			rgba(255, 255, 255, 0.2) 0%,
			rgba(155, 155, 155, 0.2) 36.68%,
			rgba(113, 112, 112, 0.2) 64.6%,
			rgba(78, 78, 78, 0.2) 100%
		),
		linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)) !important;

	border: 1px solid #e0e0e04d !important;
	border-image-source: linear-gradient(
		180deg,
		rgba(224, 224, 224, 0.37) 0%,
		rgba(255, 255, 255, 0.5) 20.52%,
		rgba(106, 106, 106, 0.5) 65%
	);
	&:hover:not([disabled]) {
		filter: brightness(150%);
		-webkit-transition: all 0.5s ease-in-out;
		-moz-transition: all 0.5s ease-in-out;
		-o-transition: all 0.5s ease-in-out;
		-ms-transition: all 0.5s ease-in-out;
		transition: all 0.5s ease-in-out;
	}
	&:disabled {
		filter: brightness(50%);
	}
`;
